var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        { staticClass: "ma-0 pa-0", attrs: { cols: "12", id: "head_title" } },
        [
          _c(
            "v-col",
            {
              staticClass: "pa-0",
              attrs: { cols: "12", id: "main_content_maxwidthset" },
            },
            [
              _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-0",
                  attrs: { align: "center", id: "header_height" },
                },
                [
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "back_clean_btn ma-0 pa-0",
                          staticStyle: {
                            color: "#08B0FF",
                            "font-size": "1rem",
                          },
                          attrs: {
                            width: "2rem",
                            height: "50px",
                            id: "back_clean_btn1",
                            elevation: "0",
                          },
                          on: { click: _vm.goSetting },
                        },
                        [_vm._v(" " + _vm._s(_vm.ts("title")) + " ")]
                      ),
                    ],
                    1
                  ),
                  _c("v-img", {
                    staticClass: "ma-0 pa-0 mr-3",
                    attrs: {
                      "max-height": "100%",
                      "max-width": "1.5rem",
                      src: require("@/assets/images/history_arrow.png"),
                    },
                  }),
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-0",
                          staticStyle: {
                            color: "#08B0FF",
                            "font-size": "1rem",
                          },
                          attrs: {
                            id: "back_clean_btn",
                            width: "auto",
                            height: "50px",
                            elevation: "0",
                          },
                          on: { click: _vm.goSearchBranchStore },
                        },
                        [_vm._v(" " + _vm._s(_vm.ts("searchFilter")) + " ")]
                      ),
                    ],
                    1
                  ),
                  _c("v-img", {
                    staticClass: "ma-0 pa-0 mr-3",
                    attrs: {
                      "max-height": "100%",
                      "max-width": "1.5rem",
                      src: require("@/assets/images/history_arrow.png"),
                    },
                  }),
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-0",
                          staticStyle: {
                            color: "#08B0FF",
                            "font-size": "1rem",
                          },
                          attrs: {
                            id: "back_clean_btn",
                            width: "auto",
                            height: "50px",
                            elevation: "0",
                          },
                          on: { click: _vm.goSearchBranchResult },
                        },
                        [_vm._v(" " + _vm._s(_vm.ts("branchSearch")) + " ")]
                      ),
                    ],
                    1
                  ),
                  _c("v-img", {
                    staticClass: "ma-0 pa-0 mr-3",
                    attrs: {
                      "max-height": "100%",
                      "max-width": "1.5rem",
                      src: require("@/assets/images/history_arrow.png"),
                    },
                  }),
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.ts("shareUserPermissionSettings")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: {
            id: "main_content_maxwidthset",
            cols: "12",
            align: "center",
          },
        },
        [
          _c(
            "v-col",
            { staticClass: "ma-0 pa-0 pt-9 mb-15", attrs: { cols: "10" } },
            [
              _c(
                "v-row",
                { staticClass: "ma-0 pa-0 mb-3", attrs: { align: "center" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.storeName == "" ? "" : _vm.storeName) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "ma-0 pa-0 mb-7", attrs: { align: "center" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.ts("shareMemberList") +
                              " (" +
                              _vm.userTotal.toString() +
                              ")"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { align: "center", justify: "end" },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchText,
                            expression: "searchText",
                          },
                        ],
                        ref: "searchText",
                        attrs: {
                          id: "input_grey",
                          type: "text",
                          placeholder: _vm.ts("userInputPlaceholder"),
                        },
                        domProps: { value: _vm.searchText },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchText = $event.target.value
                          },
                        },
                      }),
                      _c(
                        "v-btn",
                        {
                          staticClass: "blue_btn ma-0 pa-0 mr-3",
                          attrs: {
                            width: "4rem",
                            height: "2rem",
                            id: "blue_btn1",
                            elevation: "0",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.searchUser()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.t("search")) + " ")]
                      ),
                      _vm.authorities.ADD_SHARE_USER
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "blue_btn ma-0 pa-0 pl-2 pr-2",
                              attrs: {
                                width: "auto",
                                height: "2rem",
                                id: "blue_btn2",
                                elevation: "0",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openAddShareUserDialog()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.ts("addShareUserWith")) + " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0 mb-2",
                  attrs: { cols: "12", align: "left" },
                },
                [_vm._v(" " + _vm._s(_vm.ts("admin")) + " ")]
              ),
              _vm.areaLoading == false
                ? [
                    _vm.adminList.length != 0
                      ? _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                          _vm._l(
                            _vm.searching == false
                              ? _vm.adminList
                              : _vm.searchAdminList,
                            function (item, index) {
                              return _c(
                                "v-col",
                                {
                                  key: index,
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-3 pl-1 pr-1",
                                      class: {
                                        user_box_top: index == 0,
                                        user_box_bottom:
                                          index == _vm.adminList.length - 1,
                                        user_box_border:
                                          index != _vm.adminList.length - 1,
                                      },
                                      attrs: { id: "user_box", cols: "12" },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { align: "center" },
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0 pl-5",
                                              attrs: {
                                                cols: "3",
                                                align: "left",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.userName) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: {
                                                cols: "3",
                                                align: "left",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.mailAddress) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: { cols: "3" },
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(item.loginAt) + " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0 pr-2",
                                              attrs: {
                                                cols: "3",
                                                align: "right",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "white_btn ma-0 pa-0 pl-2 pr-2",
                                                  attrs: {
                                                    width: "auto",
                                                    height: "2rem",
                                                    elevation: "0",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showMaintainerDetail(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.t("detailView")
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          1
                        )
                      : _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                          [_vm._v(" " + _vm._s(_vm.t("noData")) + " ")]
                        ),
                  ]
                : [
                    _c(
                      "v-row",
                      { staticClass: "ma-0 pa-0", attrs: { justify: "start" } },
                      [
                        _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                          [
                            _c("v-skeleton-loader", {
                              staticStyle: { height: "9rem" },
                              attrs: {
                                boilerplate: false,
                                elevation: "0",
                                dark: "",
                                type: "image",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0 mt-7 mb-2",
                  attrs: { cols: "12", align: "left" },
                },
                [_vm._v(" " + _vm._s(_vm.ts("normalUser")) + " ")]
              ),
              _vm.areaLoading == false
                ? [
                    _vm.normalUserList.length != 0
                      ? _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                          _vm._l(
                            _vm.searching == false
                              ? _vm.normalUserList
                              : _vm.searchNormalUserList,
                            function (item, index) {
                              return _c(
                                "v-col",
                                {
                                  key: item.email,
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-3 pl-1 pr-1",
                                      class: {
                                        user_box_top: index == 0,
                                        user_box_bottom:
                                          index ==
                                          _vm.normalUserList.length - 1,
                                        user_box_border:
                                          index !=
                                          _vm.normalUserList.length - 1,
                                      },
                                      attrs: { id: "user_box", cols: "12" },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { align: "center" },
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0 pl-5",
                                              attrs: {
                                                cols: "3",
                                                align: "left",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.userName) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: {
                                                cols: "3",
                                                align: "left",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.mailAddress) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: { cols: "3" },
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(item.loginAt) + " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0 pr-2",
                                              attrs: {
                                                cols: "3",
                                                align: "right",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "white_btn ma-0 pa-0 pl-2 pr-2",
                                                  attrs: {
                                                    width: "auto",
                                                    height: "2rem",
                                                    elevation: "0",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showUserSettingDetail(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.t("detailView")
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          1
                        )
                      : _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                          [_vm._v(" " + _vm._s(_vm.t("noData")) + " ")]
                        ),
                  ]
                : [
                    _c(
                      "v-row",
                      { staticClass: "ma-0 pa-0", attrs: { justify: "start" } },
                      [
                        _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                          [
                            _c("v-skeleton-loader", {
                              staticStyle: { height: "9rem" },
                              attrs: {
                                boilerplate: false,
                                elevation: "0",
                                dark: "",
                                type: "image",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-3 mt-5 mb-2 pl-5 pr-0",
                  attrs: { id: "add_group_divider", cols: "12", align: "left" },
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.ts("privilegeGroupCreation")) + " "
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "back_clean_btn ma-0 pa-0 ml-2",
                          attrs: {
                            width: "auto",
                            height: "auto",
                            id: "back_clean_btn2",
                            elevation: "0",
                          },
                          on: { click: _vm.newPrivilegeGroup },
                        },
                        [
                          _c("v-img", {
                            staticClass: "ma-0 pa-0",
                            attrs: {
                              "max-height": "1.5rem",
                              "max-width": "1.5rem",
                              src: require("@/assets/images/plus_round.png"),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.areaLoading == false && _vm.privilegeGroupList.length != 0
                    ? _vm._l(
                        _vm.searching == false
                          ? _vm.privilegeGroupList
                          : _vm.searchPrivilegeGroupList,
                        function (item, index) {
                          return _c(
                            "v-row",
                            {
                              key: index,
                              staticClass: "ma-0 pa-0 mt-2",
                              attrs: { id: "new_group_result" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-3 pl-1 pr-1",
                                  attrs: { id: "user_box" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        align: "center",
                                        id: "auth_group",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0 pl-5",
                                          attrs: { cols: "3", align: "left" },
                                        },
                                        [_vm._v(" " + _vm._s(item.name) + " ")]
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0 pr-2",
                                          attrs: { cols: "9", align: "right" },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: { justify: "end" },
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: { cols: "auto" },
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "ma-0 pa-0 pl-2 pr-2",
                                                      attrs: {
                                                        id: "transparent_btn",
                                                        width: "auto",
                                                        height: "2rem",
                                                        elevation: "0",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.modifyPrivilegeGroup(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-img", {
                                                        attrs: {
                                                          src: require("@/assets/images/icon_setting.png"),
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: { cols: "auto" },
                                                },
                                                [
                                                  _c(
                                                    "v-menu",
                                                    {
                                                      attrs: { "offset-y": "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function (ref) {
                                                              var on = ref.on
                                                              var attrs =
                                                                ref.attrs
                                                              return [
                                                                _c(
                                                                  "v-btn",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        staticClass:
                                                                          "ma-0 pa-0 pl-2 pr-2",
                                                                        attrs: {
                                                                          id: "transparent_btn",
                                                                          width:
                                                                            "auto",
                                                                          height:
                                                                            "2rem",
                                                                          elevation:
                                                                            "0",
                                                                        },
                                                                      },
                                                                      "v-btn",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-img",
                                                                      {
                                                                        attrs: {
                                                                          src: require("@/assets/images/dots.png"),
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _c(
                                                        "v-list",
                                                        {
                                                          attrs: {
                                                            id: "auth_group_menu_list",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              attrs: {
                                                                ripple: false,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                {
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.deletePrivilegeGroup(
                                                                          item
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.ts(
                                                                          "privilegeGroupDelete"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._l(
                                item.accountAuthGroupList,
                                function (item_account, index_account) {
                                  return _c(
                                    "v-col",
                                    {
                                      key: index_account,
                                      staticClass: "ma-0 pa-0",
                                      staticStyle: {
                                        "border-top": "1px solid #707070",
                                      },
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-3 pl-1 pr-1",
                                          class: {
                                            user_box_top: index_account == 0,
                                            user_box_bottom:
                                              index_account ==
                                              item.accountAuthGroupList.length -
                                                1,
                                            user_box_border:
                                              index_account !=
                                              item.accountAuthGroupList.length -
                                                1,
                                          },
                                          attrs: { id: "user_box", cols: "12" },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: { align: "center" },
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "ma-0 pa-0 pl-5",
                                                  attrs: {
                                                    cols: "3",
                                                    align: "left",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item_account.userName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: {
                                                    cols: "3",
                                                    align: "left",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item_account.mailAddress
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: { cols: "3" },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item_account.loginAt
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "ma-0 pa-0 pr-2",
                                                  attrs: {
                                                    cols: "3",
                                                    align: "right",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "white_btn ma-0 pa-0 pl-2 pr-2",
                                                      attrs: {
                                                        width: "auto",
                                                        height: "2rem",
                                                        elevation: "0",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.showUserDetail(
                                                            item_account
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.t("detailView")
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        }
                      )
                    : _vm.areaLoading == false &&
                      _vm.privilegeGroupList.length == 0
                    ? [
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0",
                            attrs: { align: "center" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                staticStyle: { "text-align": "center" },
                                attrs: { cols: "12" },
                              },
                              [_vm._v(" " + _vm._s(_vm.t("noData")) + " ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    : [
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0",
                            attrs: { justify: "start" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "12" },
                              },
                              [
                                _c("v-skeleton-loader", {
                                  staticStyle: { height: "9rem" },
                                  attrs: {
                                    boilerplate: false,
                                    elevation: "0",
                                    dark: "",
                                    type: "image",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                ],
                2
              ),
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0 mt-9 mb-2",
                  attrs: { cols: "12", align: "left" },
                },
                [_vm._v(" " + _vm._s(_vm.ts("viewer")) + " ")]
              ),
              _vm.areaLoading == false
                ? [
                    _vm.viewerList.length != 0
                      ? _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                          _vm._l(
                            _vm.searching == false
                              ? _vm.viewerList
                              : _vm.searchViewerList,
                            function (item, index) {
                              return _c(
                                "v-col",
                                {
                                  key: item.email,
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-3 pl-1 pr-1",
                                      class: {
                                        user_box_top: index == 0,
                                        user_box_bottom:
                                          index == _vm.viewerList.length - 1,
                                        user_box_border:
                                          index != _vm.viewerList.length - 1,
                                      },
                                      attrs: { id: "user_box", cols: "12" },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { align: "center" },
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0 pl-5",
                                              attrs: {
                                                cols: "3",
                                                align: "left",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.userName) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: {
                                                cols: "3",
                                                align: "left",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.mailAddress) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: { cols: "3" },
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(item.loginAt) + " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0 pr-2",
                                              attrs: {
                                                cols: "3",
                                                align: "right",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "white_btn ma-0 pa-0 pl-2 pr-2",
                                                  attrs: {
                                                    width: "auto",
                                                    height: "2rem",
                                                    elevation: "0",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showUserDetail(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.t("detailView")
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          1
                        )
                      : _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                          [_vm._v(" " + _vm._s(_vm.t("noData")) + " ")]
                        ),
                  ]
                : [
                    _c(
                      "v-row",
                      { staticClass: "ma-0 pa-0", attrs: { justify: "start" } },
                      [
                        _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                          [
                            _c("v-skeleton-loader", {
                              staticStyle: { height: "9rem" },
                              attrs: {
                                boilerplate: false,
                                elevation: "0",
                                dark: "",
                                type: "image",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0 mt-7 mb-2",
                  staticStyle: { color: "red" },
                  attrs: { cols: "12", align: "left" },
                },
                [_vm._v(" " + _vm._s(_vm.ts("blockUser")) + " ")]
              ),
              _vm.areaLoading == false
                ? [
                    _vm.blackList.length != 0
                      ? _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                          _vm._l(
                            _vm.searching == false
                              ? _vm.blackList
                              : _vm.searchBlackList,
                            function (item, index) {
                              return _c(
                                "v-col",
                                {
                                  key: item.email,
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-3 pl-1 pr-1",
                                      class: {
                                        user_box_top: index == 0,
                                        user_box_bottom:
                                          index == _vm.blackList.length - 1,
                                        user_box_border:
                                          index != _vm.blackList.length - 1,
                                      },
                                      attrs: { id: "user_box", cols: "12" },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: { align: "center" },
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0 pl-5",
                                              attrs: {
                                                cols: "3",
                                                align: "left",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.userName) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: {
                                                cols: "3",
                                                align: "left",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.mailAddress) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: { cols: "3" },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.ts("blockUser")) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0 pr-2",
                                              attrs: {
                                                cols: "3",
                                                align: "right",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "white_btn ma-0 pa-0 pl-2 pr-2",
                                                  attrs: {
                                                    width: "auto",
                                                    height: "2rem",
                                                    elevation: "0",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showUserDetail(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.t("detailView")
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          1
                        )
                      : _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                          [_vm._v(" " + _vm._s(_vm.t("noData")) + " ")]
                        ),
                  ]
                : [
                    _c(
                      "v-row",
                      { staticClass: "ma-0 pa-0", attrs: { justify: "start" } },
                      [
                        _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                          [
                            _c("v-skeleton-loader", {
                              staticStyle: { height: "9rem" },
                              attrs: {
                                boilerplate: false,
                                elevation: "0",
                                dark: "",
                                type: "image",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0 mt-9 mb-2",
                  attrs: { cols: "12", align: "left" },
                },
                [_vm._v(" " + _vm._s(_vm.ts("usenTemporaryAccount")) + " ")]
              ),
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-3 pl-1 pr-1",
                  attrs: { id: "user_box_alone", cols: "12" },
                },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { align: "center", justify: "space-between" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 pl-5",
                          attrs: { cols: "4", align: "left" },
                        },
                        [
                          _vm._v(
                            " " + _vm._s("USEN" + _vm.ts("maintenance")) + " "
                          ),
                        ]
                      ),
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { align: "center", justify: "end" },
                        },
                        [
                          _vm.usenTemporaryUser
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 mr-3",
                                  attrs: { cols: "auto" },
                                },
                                [_vm._v(" " + _vm._s(_vm.ts("enabled")) + " ")]
                              )
                            : _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 mr-3",
                                  attrs: { cols: "auto" },
                                },
                                [_vm._v(" " + _vm._s(_vm.ts("invalid")) + " ")]
                              ),
                          _c("v-switch", {
                            staticClass: "ma-0 pa-0",
                            attrs: { "hide-details": "" },
                            on: {
                              click: function ($event) {
                                return _vm.clickToggle(_vm.usenTemporaryUser)
                              },
                            },
                            model: {
                              value: _vm.usenTemporaryUser,
                              callback: function ($$v) {
                                _vm.usenTemporaryUser = $$v
                              },
                              expression: "usenTemporaryUser",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-3 pl-1 pr-1",
                  attrs: { id: "user_box_toggle", cols: "12" },
                },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-0 mb-1",
                      attrs: { align: "center" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 pl-5",
                          attrs: { cols: "4", align: "right" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.ts("emailAddressToAllowAccess")) +
                              " : "
                          ),
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 pl-5",
                          attrs: { cols: "auto", align: "left" },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.tempMailAddress,
                                expression: "tempMailAddress",
                              },
                            ],
                            staticClass: "email_input",
                            attrs: { placeholder: "" },
                            domProps: { value: _vm.tempMailAddress },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.tempMailAddress = $event.target.value
                              },
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-0 mb-1",
                      attrs: { align: "center" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 pl-5",
                          attrs: { cols: "4", align: "right" },
                        },
                        [_vm._v(" " + _vm._s(_vm.ts("endDaySetting")) + " : ")]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 pl-5",
                          attrs: { cols: "4", align: "left" },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.formatDateValue,
                                expression: "formatDateValue",
                              },
                            ],
                            staticClass: "date_input",
                            attrs: { placeholder: "", readonly: "" },
                            domProps: { value: _vm.formatDateValue },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.formatDateValue = $event.target.value
                              },
                            },
                          }),
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 pl-2",
                          attrs: { cols: "auto", align: "left" },
                        },
                        [
                          _c("CustomDatePicker", {
                            attrs: {
                              viewTextField: false,
                              defaultOneday: true,
                              validPeriod: true,
                              eventExist: false,
                            },
                            on: { resultDate: _vm.resultDateFunc },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 pl-5 pt-2",
                          attrs: { cols: "4", align: "right" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.ts("contentOfCommunication")) +
                              " : "
                          ),
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 pl-5",
                          attrs: { cols: "auto", align: "left" },
                        },
                        [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.tempMessage,
                                expression: "tempMessage",
                              },
                            ],
                            staticClass: "content_input",
                            attrs: { placeholder: "メンテナンス" },
                            domProps: { value: _vm.tempMessage },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.tempMessage = $event.target.value
                              },
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 pr-2",
                          attrs: { cols: "12", align: "right" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "blue_btn",
                              attrs: { loading: _vm.loading, id: "blue_btn3" },
                              on: { click: _vm.addMaintenanceUser },
                            },
                            [_vm._v(" " + _vm._s(_vm.t("send")) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("AddShareUserDialog", {
        attrs: {
          dialogVisible: _vm.addShareUserDialogVisible,
          fromBranchShare: _vm.fromBranchShareData,
          unisCustomerCd: _vm.unisCustomerCd,
        },
        on: {
          visible: _vm.addShareUserDialogVisibleFunc,
          branchShareUser: _vm.branchShareUserFunc,
        },
      }),
      _c("UserDetailDialog", {
        attrs: {
          dialogVisible: _vm.userDetailDialogVisible,
          detailUser: _vm.detailUser,
        },
        on: { visible: _vm.userDetailDialogVisibleFunc },
      }),
      _c("AuthorityGroupDialog", {
        attrs: {
          dialogVisible: _vm.authorityGroupDialogVisible,
          isBranch: _vm.isBranch,
          isUserAuthorityDetail: _vm.isUserAuthorityDetail,
          userAuthorityDetail: _vm.userAuthorityDetail,
          privilegeGroupList: _vm.privilegeGroupList,
          privilegeGroupName: _vm.privilegeGroupName,
          privilegeGroupData: _vm.privilegeGroupData,
        },
        on: {
          visible: _vm.authorityGroupDialogVisibleFunc,
          showGroupDialog: _vm.showGroupDialogResult,
          modified: _vm.modifiedReloadFunc,
        },
      }),
      _c("DeleteShareGroupDialog", {
        attrs: {
          dialogVisible: _vm.deleteShareGroupDialogVisible,
          deleteGroupId: _vm.deleteGroupId,
        },
        on: {
          visible: _vm.deleteShareGroupDialogVisibleFunc,
          isDeleted: _vm.isDeletedFunc,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }